var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerSkippedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 102,
    viewBox: "0 0 96 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_205_12880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 30L34 24L42 18H52L60 22L66 30L68 36L66 46L62 56L54 70L48 78L38 64L30 48L28 42L30 30Z",
    fill: "#e39d12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 49.9058C45.6266 49.9058 43.3065 49.1998 41.3332 47.8771C39.3598 46.5544 37.8217 44.6744 36.9135 42.4748C36.0052 40.2752 35.7676 37.8548 36.2306 35.5198C36.6936 33.1847 37.8365 31.0398 39.5147 29.3563C41.193 27.6728 43.3311 26.5263 45.6589 26.0619C47.9867 25.5974 50.3995 25.8358 52.5922 26.7469C54.7849 27.658 56.6591 29.2009 57.9776 31.1804C59.2962 33.16 60 35.4874 60 37.8682C60 41.0608 58.7357 44.1226 56.4853 46.3801C54.2348 48.6376 51.1826 49.9058 48 49.9058V49.9058ZM48 29.8431C46.4178 29.8431 44.871 30.3138 43.5554 31.1956C42.2398 32.0774 41.2145 33.3307 40.609 34.7971C40.0035 36.2635 39.845 37.8771 40.1537 39.4338C40.4624 40.9905 41.2243 42.4205 42.3431 43.5428C43.462 44.6651 44.8874 45.4294 46.4393 45.7391C47.9911 46.0487 49.5997 45.8898 51.0615 45.2824C52.5233 44.675 53.7727 43.6464 54.6518 42.3267C55.5308 41.007 56 39.4554 56 37.8682C56 35.7398 55.1571 33.6986 53.6569 32.1936C52.1566 30.6886 50.1217 29.8431 48 29.8431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 80C47.2159 79.9939 46.4508 79.7567 45.8 79.3179C45.3418 79.0395 44.9575 78.654 44.68 78.1944C44.68 77.9135 26 49.4646 26 38.069C26 32.2159 28.3179 26.6026 32.4437 22.4639C36.5695 18.3251 42.1652 16 48 16C53.8348 16 59.4306 18.3251 63.5564 22.4639C67.6822 26.6026 70 32.2159 70 38.069C70 49.6652 51.52 78.1944 51.32 78.395C51.0314 78.8209 50.659 79.1831 50.2256 79.4591C49.7922 79.7351 49.307 79.9192 48.8 80H48ZM48 19.8119C43.2294 19.8225 38.6571 21.7283 35.2837 25.1122C31.9104 28.4962 30.0106 33.0827 30 37.8683C30 45.5724 41.72 66.4777 48 75.9875C54.28 66.4777 66 45.5724 66 37.8683C65.9894 33.0827 64.0896 28.4962 60.7163 25.1122C57.3429 21.7283 52.7706 19.8225 48 19.8119V19.8119Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_205_12880",
    x: -16,
    y: -12,
    width: 128,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_205_12880"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect1_dropShadow_205_12880",
    result: "effect2_dropShadow_205_12880"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_205_12880",
    result: "effect3_dropShadow_205_12880"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_205_12880",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerSkippedIcon);
export default __webpack_public_path__ + "static/media/marker-skipped-icon.9daf10c4512fb9e765b27c1196919c01.svg";
export { ForwardRef as ReactComponent };